import { config } from "../config";
const ACCESS_TOKEN_KEY = "admin_access_token";
const REFRESH_TOKEN_KEY = "admin_refresh_token";
/**
 * Сохраняет токены в localStorage
 */
export const saveTokens = (tokens) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
};
/**
 * Получает access токен из localStorage
 */
export const getAccessToken = () => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
};
/**
 * Получает refresh токен из localStorage
 */
export const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
};
/**
 * Удаляет токены из localStorage
 */
export const removeTokens = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};
/**
 * Проверяет, авторизован ли пользователь
 */
export const isAuthenticated = () => {
    const token = getAccessToken();
    if (!token) {
        return false;
    }
    try {
        const payloadBase64 = token.split(".")[1];
        if (!payloadBase64) {
            removeTokens();
            return false;
        }
        const payload = JSON.parse(atob(payloadBase64));
        if (!payload.id || !payload.role) {
            removeTokens();
            return false;
        }
        return true;
    }
    catch {
        removeTokens();
        return false;
    }
};
export const getAdminRole = () => {
    const token = getAccessToken();
    if (!token) {
        return null;
    }
    try {
        const payloadBase64 = token.split(".")[1];
        if (!payloadBase64) {
            return null;
        }
        const payload = JSON.parse(atob(payloadBase64));
        return payload.role ?? null;
    }
    catch {
        return null;
    }
};
/**
 * Достаёт id текущего админа из access-токена
 */
export const getAdminId = () => {
    const token = getAccessToken();
    if (!token) {
        return null;
    }
    try {
        const payloadBase64 = token.split(".")[1];
        if (!payloadBase64) {
            return null;
        }
        const payload = JSON.parse(atob(payloadBase64));
        return payload.id ?? null;
    }
    catch {
        return null;
    }
};
/**
 * Обновляет access токен используя refresh токен
 */
export const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
        return null;
    }
    try {
        const response = await fetch(`${config.apiUrl}/auth/refresh`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ refreshToken }),
        });
        if (!response.ok) {
            removeTokens();
            return null;
        }
        const data = await response.json();
        saveTokens(data);
        return data.accessToken;
    }
    catch (error) {
        console.error("Ошибка при обновлении токена:", error);
        removeTokens();
        return null;
    }
};
/**
 * Выполняет запрос с автоматическим обновлением токена при 401
 */
export const fetchWithAuth = async (url, options = {}) => {
    const token = getAccessToken();
    const headers = new Headers(options.headers);
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    if (!(options.body instanceof FormData)) {
        headers.set("Content-Type", "application/json");
    }
    let response = await fetch(url, {
        ...options,
        headers,
    });
    // Если получили 401, пытаемся обновить токен
    if (response.status === 401) {
        const newToken = await refreshAccessToken();
        if (newToken) {
            // Повторяем запрос с новым токеном
            headers.set("Authorization", `Bearer ${newToken}`);
            response = await fetch(url, {
                ...options,
                headers,
            });
        }
        else {
            // Если не удалось обновить токен, перенаправляем на страницу входа
            if (typeof window !== "undefined") {
                window.location.href = "/login";
            }
        }
    }
    if (response.status === 403) {
        console.error("Access denied: insufficient permissions");
    }
    return response;
};
